var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClapperboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3752 4.06078L1.95857 6.85245L1.83357 6.01912C1.6669 5.10245 2.2919 4.26912 3.20857 4.10245L16.3752 1.89412C17.2919 1.72745 18.1252 2.35245 18.2919 3.26912L18.3752 4.06078ZM16.9586 17.6858H3.62524C2.70857 17.6858 1.95857 16.9358 1.95857 16.0191V6.85245H18.6252V16.0191C18.6252 16.9358 17.8752 17.6858 16.9586 17.6858Z",
    fill: "url(#paint0_linear_6902_8232)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12516 3.26953L10.1668 5.47786L11.8335 5.1862L9.75016 2.97786L8.12516 3.26953ZM4.8335 3.8112L6.87516 6.01953L8.54183 5.72787L6.4585 3.5612L4.8335 3.8112ZM11.4168 2.72786L13.4585 4.89453L15.0835 4.64453L13.0418 2.4362L11.4168 2.72786ZM14.6668 2.1862L16.7502 4.35286L18.3752 4.0612L16.3335 1.89453L14.6668 2.1862Z",
    fill: "#FFF1C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41699 6.01953C3.76217 6.01953 4.04199 5.73971 4.04199 5.39453C4.04199 5.04935 3.76217 4.76953 3.41699 4.76953C3.07181 4.76953 2.79199 5.04935 2.79199 5.39453C2.79199 5.73971 3.07181 6.01953 3.41699 6.01953Z",
    fill: "#FFF1C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9585 6.85352L15.2918 9.35352H16.9585L18.6252 6.85352H16.9585ZM13.6252 6.85352L11.9585 9.35352H13.6252L15.2918 6.85352H13.6252ZM10.2918 6.85352L8.62516 9.35352H10.2918L11.9585 6.85352H10.2918ZM6.9585 6.85352L5.29183 9.35352H6.9585L8.62516 6.85352H6.9585ZM3.62516 6.85352L1.9585 9.35352H3.62516L5.29183 6.85352H3.62516Z",
    fill: "#FFF1C6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6902_8232",
    x1: 10.2159,
    y1: 1.86719,
    x2: 10.2159,
    y2: 17.6858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AF17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520834,
    stopColor: "#F2C236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7A100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapperboard);
export default __webpack_public_path__ + "static/media/clapperboard.05ee1d5cbe3cbbb9f876262d297af8d9.svg";
export { ForwardRef as ReactComponent };